import { IDocumentsData } from "~/types/entities";

export default () => {
  const { t } = useI18n();

  const DOCUMENTS_DATA: IDocumentsData = {
    license: {
      title: t("Documents for legal entities"),
      items: ["corporate_policy", "license"],
    },
    "user-agreements": {
      title: t("User agreements"),
      items: ["individual_license", "policy", "rule", "cookie", "chatbot_privacy_policy", "chatbot_data_processing_agreement"],
    },
  };

  const DOCUMENTS_DATA_ITEMS = [
    ...new Set(
      Object.values(DOCUMENTS_DATA)
        .map((item) => item.items)
        .flat(1)
    ),
  ];

  return {
    DOCUMENTS_DATA,
    DOCUMENTS_DATA_ITEMS,
  };
};
